// extracted by mini-css-extract-plugin
export var logo = "_4t-2";
export var logoWrapper = "_4t-1";
export var strip = "_4t-0";